import { Node } from '@xyflow/react';
import { RfNodeSection, SweepCanvasRfNode } from '../canvas-types/nodeTypesData';
import { ObjectOperations } from '../node-changes-event-handlers/objectOperations';
import { CanvasElementType } from '../canvas-types';
import { isSectionSupportedDropElement } from '../canvas-element-tool/helper';

export const clearSectionIsDropTargetProperty = (
  nodeOperations: ObjectOperations<SweepCanvasRfNode>,
) => {
  nodeOperations.affectAllObjectsWithPartial((node) => {
    if (node.type === CanvasElementType.SECTION && node.data.isDropTarget) {
      return { ...node, data: { ...node.data, isDropTarget: false } };
    }
    return node;
  });
  return nodeOperations;
};

export const updateSectionIsDropTargetProperty = ({
  intersectionSectionNode,
  dragging,
  nodeOperations,
  nodeType,
}: {
  intersectionSectionNode: Node | null;
  dragging?: boolean;
  nodeOperations: ObjectOperations<SweepCanvasRfNode>;
  nodeType?: CanvasElementType;
}) => {
  if (!nodeType) return;

  if (intersectionSectionNode && dragging && isSectionSupportedDropElement(nodeType)) {
    nodeOperations.setObject<RfNodeSection>(intersectionSectionNode.id, (node) => ({
      ...node,
      data: { ...node.data, isDropTarget: true },
    }));
  } else {
    clearSectionIsDropTargetProperty(nodeOperations);
  }
};
